import React from "react";
import Routes from "./index";
import ScrollToTop from "./scroll-to-top";

const RoutesWrapper: React.FC = () => {

  return (
    <div>
      <ScrollToTop />
      <Routes />
    </div>
  );
};

export default RoutesWrapper;
